export const INIT_APP = 'ViewFabricGreetingCard/*/Init';
export const PROPAGATE_STEP_CHANGE = 'ViewFabricGreetingCard/*/PropagateStepChange';
export const SET_ALL_ASSETS = 'ViewFabricGreetingCard/*/AllAssets';
